/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { InputStyle, InputType } from "src/constants/theme.constant";
import { useState, useEffect } from "react";
import Input from "../atoms/input.component";
import { CloseIcon, SearchIcon } from "../icons.component";

type SearchInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  className?: string;
  style?: InputStyle;
  value?: string,
  onSearch?: (value: any) => void;
};

const SearchInput = ({
  className,
  style = InputStyle.Primary,
  value,
  onSearch,
  ...props
} : SearchInputProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [inputValue, setInputValue] = useState<string | undefined>(value);
  
  const handleSearch = () => {
    onSearch && onSearch(inputValue);
  };

  const handleClearSearch = () => {
    setInputValue('');
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    props.onChange && props.onChange(e);
  };

  useEffect(() => {
    setInputValue(value || '');
    return () => {
      setInputValue('');
    };
  }, [value]);

  return (
    <>
      <div className={`input-search ${className ?? ''}`}>
        <Input
          {...{style, ...props}}
          className={`${isFocused ? 'input--focused':''} ${isHovered ? 'input--hover':''} `}
          type={InputType.Text}
          value={inputValue}
          onChange={handleChange}
          onFocus={()=>setIsFocused(true)} 
          onBlur={()=>setIsFocused(false)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        />
        {inputValue && inputValue.length > 0 && (
          <button type="button" 
            className={`input-search-clear input-search-clear-${style}
            ${isFocused ? 'input-search-clear--focused':''} 
            ${isHovered ? 'input-search-clear--hover':''}`}
            onClick={handleClearSearch}
            disabled={props.disabled}
          >
            <CloseIcon />
          </button>
        )}
        <button className={`input-search-btn input-search-btn-${style} 
            ${isFocused ? 'input-search-btn--focused':''} 
            ${isHovered ? 'input-search-btn--hover':''}`}
          onClick={handleSearch}
          type="button"
          onFocus={()=>setIsFocused(true)} 
          onBlur={()=>setIsFocused(false)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          disabled={props.disabled}
        >
          <SearchIcon />
        </button>
      </div>
    </>
  );
};

export default SearchInput;
